import { useEffect, useMemo } from "react"

import { useMapDispatchContext, useMapStateContext } from "@l2r-front/l2r-map"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"
import { BottomSheetHeights, useApplicationStateContext } from "@l2r-front/l2r-utils"

import * as Styled from "./MapWithPhotoViewer.styled"

export function MapWithPhotoViewer(props) {

    const {
        className,
        topLeftElements,
        topRightElements,
        bottomLeftElements,
        bottomRightElements,
        children,
        ...otherProps
    } = props
    const { mapHeightPct } = useMapStateContext()
    const { currentBottomSheetHeight } = useApplicationStateContext()
    const isMobile = useIsMobileDevice()
    const { getMapRef } = useMapDispatchContext()
    const map = useMemo(() => {
        return getMapRef()?.getMap()
    }, [getMapRef])

    useEffect(() => {
        const frame = requestAnimationFrame(() => {
            if (map) {
                map.resize()
            }
        })
        return () => cancelAnimationFrame(frame)
    }, [map, mapHeightPct])

    const displayMapButtons = useMemo(() => {
        if (!isMobile) {
            return true
        }
        if (mapHeightPct > 50 && currentBottomSheetHeight <= BottomSheetHeights.FULL) {
            return true
        }
        return false
    }, [currentBottomSheetHeight, isMobile, mapHeightPct])

    const cornerElements = useMemo(() => {
        return {
            topLeftElements: displayMapButtons ? topLeftElements : null,
            topRightElements: displayMapButtons ? topRightElements : null,
            bottomLeftElements: displayMapButtons ? bottomLeftElements : null,
            bottomRightElements: displayMapButtons ? bottomRightElements : null,
        }
    }, [displayMapButtons, topLeftElements, topRightElements, bottomLeftElements, bottomRightElements])

    return <Styled.MapWithPhotoViewerContainer className={className} fullScreenMode={!isMobile && mapHeightPct === 0}>
        {mapHeightPct !== 100 ? <Styled.ImageViewerContainer mapHeightPct={mapHeightPct} /> : null}
        <Styled.Map {...otherProps}
            displayZoomButtons={displayMapButtons}
            displayRecenterButton={displayMapButtons}
            displayMapLayerSelector={displayMapButtons}
            keyboard={mapHeightPct > 50}
            mapHeightPct={mapHeightPct}
            {...cornerElements}>
            {children}
        </Styled.Map>
    </Styled.MapWithPhotoViewerContainer>
}

MapWithPhotoViewer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
}